import React, { useState } from 'react'
import SbEditable from 'storyblok-react'
import Slider from 'react-slick'
import RichText from 'src/utils/RichText'
import Label from 'src/components/Label'
import Heading from 'src/components/Heading'
import Logo from './Logo'

const PrevArrow = props => {
  const { onClick } = props
  return (
    <div
      className={
        'group h-11 w-11 duration-300 flex items-center justify-center rounded-full absolute -left-4 top-[calc(50%-44px)] z-10 border hover:border-2 border-brightgreen hover:bg-brightgreen/20'
      }
      onClick={onClick}
      onKeyDown={onClick}
      role="button"
      tabIndex={0}
    >
      <i className="fa-solid fa-chevron-left text-darkblue duration-300"></i>
    </div>
  )
}

const NextArrow = props => {
  const { onClick } = props
  return (
    <div
      className={
        'group h-11 w-11 duration-300 flex items-center justify-center rounded-full absolute -right-4 top-[calc(50%-44px)] z-10 border hover:border-2 border-brightgreen hover:bg-brightgreen/20'
      }
      onClick={onClick}
      onKeyDown={onClick}
      role="button"
      tabIndex={0}
    >
      <i className="fa-solid fa-chevron-right text-darkblue duration-300"></i>
    </div>
  )
}

const LogoCloudsSlider = ({ blok }) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 8000,
    slidesToShow: blok.logos.length > 4 ? 5 : blok.logos.length,
    slidesToScroll: 5,
    dotsClass: `slick-dots lg:!block !hidden !-bottom-0`,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    beforeChange: (current, next) => setCurrentIndex(next),
    appendDots: dots => (
      <div>
        <ul>
          {dots.map((item, i) => (
            <li
              className={`!m-[6px] rounded-full !h-3 !w-5 duration-300 ${i === currentIndex / 5 && ''}`}
              key={i}
            >
              {item.props.children}
            </li>
          ))}
        </ul>
      </div>
    ),
    customPaging: i => (
      <div
        className={`relative w-full h-full transition-colors rounded-full duration-300
                ${i === currentIndex / 5 ? 'bg-brightgreen' : 'bg-[#A9BBC2]'}`}
      ></div>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  }

  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className="bg-white">
        <div className="max-w-7xl mx-auto px-6 my-40 lg:my-64">
          <div className="flex flex-col justify-center items-center gap-2">
            <Label className="text-lightblue-300" p={true}>
              {blok.label}
            </Label>
            <Heading
              size="h2"
              className="text-center max-w-2xl mt-2 text-darkblue brightgreenBold"
            >
              <RichText>{blok.title}</RichText>
            </Heading>
          </div>
          {!blok.disable_slider ? (
            <Slider {...settings} className="mt-16 px-4 lg:pb-20">
              {blok.logos?.map(logo => (
                <Logo {...logo} />
              ))}
            </Slider>
          ) : (
            <div className="grid grid-cols-2 gap-12 md:grid-cols-3 lg:grid-cols-5 mt-10">
              {blok.logos?.map(logo => (
                <Logo {...logo} />
              ))}
            </div>
          )}
        </div>
      </div>
    </SbEditable>
  )
}

export default LogoCloudsSlider
